import { apiServer } from '../settings'
import {getToken} from './token'

const getScoreEvents = (game, guid, done) => {
	if (!game) return done('missing game')
	if (!guid) return done('missing guid')

	const headers = new Headers({'Authorization': 'Bearer ' + getToken()})

	const options = { method: 'GET', headers, mode: 'cors', cache: 'default' }

	const url = `${apiServer}/logger/get-score-events?game=${game}&guid=${guid}&start=0&stop=-1`

	fetch(url, options)
		.then(function(response) {
			return response.json()
		})
		.then(function(response) {
			if (response.success === false) return done(response.err)
			if (response.success === true) return done(null, response.data)
			if (!response.success) return done('response without success true|false')
		})
}


export default getScoreEvents
